import { Component } from '@angular/core';
import { ToastComponent } from "../../../../../shared/components/toast/toast.component";
import { AdminTopbarComponent } from "../../../components/admin-topbar/admin-topbar.component";
import { AdminNavigationComponent } from "../../../components/admin-navigation/admin-navigation.component";
import { TranslocoPipe } from '@jsverse/transloco';
import { DropDownSectionComponent } from "../../../../../shared/components/drop-down-section/drop-down-section.component";

@Component({
  selector: 'app-admin-company-dashboard',
  standalone: true,
  imports: [ToastComponent, AdminTopbarComponent, AdminNavigationComponent, TranslocoPipe, DropDownSectionComponent],
  templateUrl: './admin-company-dashboard.component.html',
  styleUrl: './admin-company-dashboard.component.css'
})
export class AdminCompanyDashboardComponent {

}
